<template>
  <b-modal
    id="orderMessage"
    :title="`Order: ${orderid || '-'} - SN: ${sn} ${person}`"
    :visible="show"
    size="lg"
    hide-footer
    @hidden="close"
    @close="close"
    @bv::modal::hide="close"
    @bv::modal::hidden="close"
  >
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Information" active>
          <account-products-info-modal-content-tab-order-item
            :selected-order-item="selectedOrderItem"
          />
        </b-tab>
        <b-tab v-if="order" title="Order information">
          <account-products-info-modal-content-tab-order :order="order" />
        </b-tab>
      </b-tabs>
      <hr />
      <order-messages-body
        v-if="orderItemid"
        :orderid="orderid"
        :order-itemid="orderItemid"
      />
    </div>
  </b-modal>
</template>

<script>
import OrderMessagesBody from "@/components/order/OrderMessagesBody.vue";
import AccountProductsInfoModalContentTabOrder from "../products/AccountProductsInfoModalContentTabOrder.vue";
import AccountProductsInfoModalContentTabOrderItem from "../products/AccountProductsInfoModalContentTabOrderItem.vue";
import {getOrder} from "@/services/order/getOrder";

export default {
  name: "OrderMessages",
  components: {
    OrderMessagesBody,
    AccountProductsInfoModalContentTabOrder,
    AccountProductsInfoModalContentTabOrderItem,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderid: {
      type: String,
      required: true,
    },
    orderItemid: {
      type: [Number, null],
      required: false,
      default: null,
    },
    sn: {
      type: String,
      required: false,
      default: "",
    },
    person: {
      type: String,
      required: false,
      default: "",
    },
    selectedOrderItem: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      order: null,
    };
  },
  watch: {
    orderid(orderID) {
      if (orderID) {
        this.fetchOrder();
      }
    },
  },
  created() {
    if (!this.orderid) return;
    this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      this.order = await getOrder({orderId: this.orderid});
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.message-header {
  justify-content: space-between;
}
.actions {
  width: 100%;
  justify-content: space-between;
}
</style>
